export const tags = [{
  'label': 'Property Tags',
  'value': 'parent-1',
  'children': [{ 'label': 'Bar', 'value': '2' }, {
    'label': 'Beach',
    'value': 'parent-3',
    'children': [{
      'label': 'Time of Day',
      'value': 'parent-4',
      'children': [{ 'label': 'Dawn/Sunrise', 'value': '5' }, {
        'label': 'Day',
        'value': '6'
      }, { 'label': 'Dusk/Sunset', 'value': '7' }, { 'label': 'Evening/Night', 'value': '8' }]
    }]
  }, {
    'label': 'Business/Events',
    'value': 'parent-9',
    'children': [{ 'label': 'Business Services/Center', 'value': '10' }, {
      'label': 'Event',
      'value': 'parent-11',
      'children': [{ 'label': 'Banquet', 'value': '12' }, {
        'label': 'Conference',
        'value': '13'
      }, { 'label': 'Exhibition', 'value': '14' }, {
        'label': 'Group Event',
        'value': '15'
      }, { 'label': 'Trade Show/Conference', 'value': '16' }, { 'label': 'Wedding', 'value': '17' }]
    }, { 'label': 'Fax', 'value': '18' }, {
      'label': 'Meeting Room',
      'value': 'parent-19',
      'children': [{ 'label': 'Auditorium/Amphitheater', 'value': '20' }, {
        'label': 'Ballroom',
        'value': '21'
      }, { 'label': 'Boardroom', 'value': '22' }, {
        'label': 'Conference Room',
        'value': '23'
      }, { 'label': 'Meeting Facilities', 'value': '24' }, {
        'label': 'Meeting Reception',
        'value': '25'
      }, {
        'label': 'Seating',
        'value': 'parent-26',
        'children': [{ 'label': 'Cabaret', 'value': '27' }, {
          'label': 'Chevron',
          'value': '28'
        }, { 'label': 'Circle of Chairs', 'value': '29' }, {
          'label': 'Classroom',
          'value': '30'
        }, { 'label': 'Clusters', 'value': '31' }, { 'label': 'Cocktail', 'value': '32' }, {
          'label': 'Crescent Rounds',
          'value': '33'
        }, { 'label': 'Dancefloor and Staging', 'value': '34' }, {
          'label': 'Double U',
          'value': '35'
        }, { 'label': 'Empty', 'value': '36' }, {
          'label': 'Exhibit Hall with Booths',
          'value': '37'
        }, { 'label': 'General Session', 'value': '38' }, {
          'label': 'Highboys',
          'value': '39'
        }, { 'label': 'Hollow Square Style', 'value': '40' }, {
          'label': 'Imperial',
          'value': '41'
        }, { 'label': 'Rounds', 'value': '42' }, {
          'label': 'Theater',
          'value': '43'
        }, { 'label': 'Theater in the Round', 'value': '44' }, { 'label': 'U Shape', 'value': '45' }]
      }]
    }, { 'label': 'Office', 'value': '46' }, { 'label': 'Printer', 'value': '47' }]
  }, {
    'label': 'Dining',
    'value': 'parent-48',
    'children': [{
      'label': 'Cuisine',
      'value': 'parent-49',
      'children': [{ 'label': 'American', 'value': '50' }, {
        'label': 'Asian',
        'value': '51'
      }, { 'label': 'Continental', 'value': '52' }, { 'label': 'English/Irish', 'value': '53' }, {
        'label': 'French',
        'value': '54'
      }, { 'label': 'Indian', 'value': '55' }, { 'label': 'Italian', 'value': '56' }]
    }, {
      'label': 'Dining Area',
      'value': 'parent-57',
      'children': [{ 'label': 'BBQ/Picnic Area', 'value': '58' }, {
        'label': 'Breakfast Area',
        'value': '59'
      }, { 'label': 'Buffet', 'value': '60' }, { 'label': 'Café', 'value': '61' }, {
        'label': 'Coffee shop',
        'value': '62'
      }, { 'label': 'Food Court', 'value': '63' }, { 'label': 'Grill/Pub', 'value': '64' }, {
        'label': 'Restaurant',
        'value': '65'
      }, { 'label': 'Restaurant Feature', 'value': '66' }, { 'label': 'Snack Bar', 'value': '67' }]
    }, {
      'label': 'Food/Drink',
      'value': 'parent-68',
      'children': [{ 'label': 'Coffee Service', 'value': '69' }, {
        'label': 'Drink',
        'value': '70'
      }, { 'label': 'Drink - Alcoholic', 'value': '71' }, {
        'label': 'Drink - Non-Alcoholic',
        'value': '72'
      }, { 'label': 'Food', 'value': '73' }, { 'label': 'Grocery store/supermarket', 'value': '74' }, {
        'label': 'Wine',
        'value': '75'
      }, { 'label': 'Wine Cellar', 'value': '76' }, { 'label': 'Wine Tasting', 'value': '77' }]
    }, {
      'label': 'Meals',
      'value': 'parent-78',
      'children': [{ 'label': 'Breakfast', 'value': '79' }, { 'label': 'Dinner', 'value': '80' }, {
        'label': 'Lunch',
        'value': '81'
      }]
    }]
  }, {
    'label': 'Exterior View of Building',
    'value': 'parent-82',
    'children': [{ 'label': 'Courtyard', 'value': '83' }, {
      'label': 'Entrance',
      'value': '84'
    }, { 'label': 'Featured View', 'value': '85' }, { 'label': 'Garden', 'value': '86' }, {
      'label': 'Gazebo',
      'value': '87'
    }, { 'label': 'Grounds', 'value': '88' }, { 'label': 'Lake', 'value': '89' }, {
      'label': 'Natural landscape',
      'value': '90'
    }, { 'label': 'Street', 'value': '91' }, { 'label': 'Sundeck', 'value': '92' }, {
      'label': 'Time of Day',
      'value': 'parent-93',
      'children': [{ 'label': 'Dawn/Sunrise', 'value': '94' }, {
        'label': 'Day',
        'value': '95'
      }, { 'label': 'Dusk/Sunset', 'value': '96' }, { 'label': 'Evening/Night', 'value': '97' }]
    }, {
      'label': 'View From',
      'value': 'parent-98',
      'children': [{ 'label': 'Above', 'value': '99' }, { 'label': 'Back', 'value': '100' }, {
        'label': 'Front',
        'value': '101'
      }, { 'label': 'Satellite', 'value': '102' }, { 'label': 'Street', 'value': '103' }]
    }]
  }, { 'label': 'Fitness Center', 'value': '104' }, {
    'label': 'Lobby',
    'value': 'parent-105',
    'children': [{ 'label': 'Atrium', 'value': '106' }, {
      'label': 'Check-in/out Kiosk',
      'value': '107'
    }, { 'label': 'Concierge', 'value': '108' }, { 'label': 'Entrance', 'value': '109' }, {
      'label': 'Reception',
      'value': '110'
    }, { 'label': 'Sitting area', 'value': '111' }]
  }, {
    'label': 'Miscellaneous',
    'value': 'parent-112',
    'children': [{ 'label': 'Accessibility', 'value': '113' }, {
      'label': 'Décor detail',
      'value': '114'
    }, { 'label': 'Hallway', 'value': '115' }, {
      'label': 'Logo',
      'value': 'parent-116',
      'children': [{ 'label': 'Brand Logo', 'value': '117' }, {
        'label': 'Certificate/award',
        'value': '118'
      }, { 'label': 'Property logo or sign', 'value': '119' }]
    }, { 'label': 'Parking', 'value': '120' }, { 'label': 'Parking - RV/Truck', 'value': '121' }, {
      'label': 'Pets',
      'value': '122'
    }, { 'label': 'Service', 'value': '123' }, { 'label': 'Staircase', 'value': '124' }, {
      'label': 'Valet',
      'value': '125'
    }, { 'label': 'Vending machine', 'value': '126' }]
  }, {
    'label': 'Pool',
    'value': 'parent-127',
    'children': [{ 'label': 'Children\'s Pool', 'value': '128' }, {
      'label': 'Indoor Pool',
      'value': '129'
    }, { 'label': 'Infinity Pool', 'value': '130' }, { 'label': 'Lap Pool', 'value': '131' }, {
      'label': 'Outdoor Pool',
      'value': '132'
    }, { 'label': 'Waterfall', 'value': '133' }, { 'label': 'Waterslide', 'value': '134' }, {
      'label': 'Wave Pool',
      'value': '135'
    }]
  }, {
    'label': 'Property Amenity',
    'value': 'parent-136',
    'children': [{ 'label': 'Casino', 'value': '137' }, {
      'label': 'Chapel/Place of worship',
      'value': '138'
    }, { 'label': 'Communal Kitchen', 'value': '139' }, {
      'label': 'Communal lounge/TV room',
      'value': '140'
    }, { 'label': 'Fireplace', 'value': '141' }, { 'label': 'Fountain', 'value': '142' }, {
      'label': 'Gift Shop',
      'value': '143'
    }, { 'label': 'Laundry Facilities', 'value': '144' }, {
      'label': 'Library',
      'value': '145'
    }, { 'label': 'Loyalty Program Lounge/Floor', 'value': '146' }, {
      'label': 'Pantry/Convenience Store',
      'value': '147'
    }, { 'label': 'Patio/Terrace', 'value': '148' }, {
      'label': 'Shuttle - Airport/Seaport',
      'value': '149'
    }, { 'label': 'Shuttle - City/Other', 'value': '150' }, { 'label': 'Solarium', 'value': '151' }]
  }, {
    'label': 'Spa',
    'value': 'parent-152',
    'children': [{ 'label': 'Bathhouse/Turkish Bath', 'value': '153' }, {
      'label': 'Hot springs',
      'value': '154'
    }, { 'label': 'Hot Tub', 'value': '155' }, { 'label': 'Massage', 'value': '156' }, {
      'label': 'Massage room',
      'value': '157'
    }, { 'label': 'Salon', 'value': '158' }, { 'label': 'Salon - Hair', 'value': '159' }, {
      'label': 'Salon - Nail',
      'value': '160'
    }, { 'label': 'Sauna/Steam Room', 'value': '161' }, {
      'label': 'Spa Reception',
      'value': '162'
    }, { 'label': 'Spa Treatment', 'value': '163' }, {
      'label': 'Spa Treatment Room',
      'value': '164'
    }, { 'label': 'Steam Room', 'value': '165' }]
  }]
}, {
  'label': 'Guest Room Tags',
  'value': 'parent-166',
  'children': [{ 'label': 'Accessibility', 'value': '167' }, {
    'label': 'Bathroom',
    'value': 'parent-168',
    'children': [{ 'label': 'Amenities', 'value': '169' }, { 'label': 'Shower', 'value': '170' }, {
      'label': 'Sink',
      'value': '171'
    }, { 'label': 'Toilet', 'value': '172' }, { 'label': 'Tub', 'value': '173' }, {
      'label': 'Tub - Deep Soaking',
      'value': '174'
    }, { 'label': 'Tub - Jetted', 'value': '175' }]
  }, {
    'label': 'Bed',
    'value': 'parent-176',
    'children': [{ 'label': 'Bedding', 'value': '177' }, {
      'label': 'Bunk bed',
      'value': '178'
    }, { 'label': 'Cot/Rollaway Bed', 'value': '179' }, { 'label': 'Crib', 'value': '180' }, {
      'label': 'King bed',
      'value': '181'
    }, { 'label': 'Queen bed', 'value': '182' }, { 'label': 'Sofabed', 'value': '183' }]
  }, { 'label': 'Dining area', 'value': '184' }, {
    'label': 'Guest Room',
    'value': '185'
  }, { 'label': 'Guest Room - Whole Room', 'value': '186' }, {
    'label': 'Guest Room Amenity',
    'value': 'parent-187',
    'children': [{ 'label': 'Balcony', 'value': '188' }, {
      'label': 'Business Facilities',
      'value': '189'
    }, { 'label': 'Crib', 'value': '190' }, {
      'label': 'Coffee/tea facilities',
      'value': '191'
    }, { 'label': 'Décor detail', 'value': '192' }, { 'label': 'Fireplace', 'value': '193' }, {
      'label': 'Full Bar',
      'value': '194'
    }, { 'label': 'Furnishings', 'value': '195' }, {
      'label': 'Hot Tub',
      'value': '196'
    }, { 'label': 'Kitchen/Kitchenette', 'value': '197' }, {
      'label': 'Minibar',
      'value': '198'
    }, { 'label': 'Mini-Refrigerator', 'value': '199' }, {
      'label': 'Patio/Terrace',
      'value': '200'
    }, { 'label': 'Pool', 'value': '201' }, { 'label': 'Refrigerator', 'value': '202' }, {
      'label': 'Safe',
      'value': '203'
    }, { 'label': 'Telephone', 'value': '204' }, { 'label': 'TV and multimedia', 'value': '205' }]
  }, { 'label': 'Living Area', 'value': '206' }, { 'label': 'Miscellaneous', 'value': '207' }, {
    'label': 'Pets',
    'value': '208'
  }, {
    'label': 'Room Theme',
    'value': 'parent-209',
    'children': [{ 'label': 'Children', 'value': '210' }, { 'label': 'Family', 'value': '211' }, {
      'label': 'Honeymoon',
      'value': '212'
    }]
  }, {
    'label': 'Room Type',
    'value': 'parent-213',
    'children': [{ 'label': 'Apartment', 'value': '214' }, { 'label': 'Budget', 'value': '215' }, {
      'label': 'Deluxe',
      'value': '216'
    }, { 'label': 'Double', 'value': '217' }, { 'label': 'Quad', 'value': '218' }, {
      'label': 'Single',
      'value': '219'
    }, { 'label': 'Standard', 'value': '220' }, { 'label': 'Superior', 'value': '221' }, {
      'label': 'Triple',
      'value': '222'
    }, { 'label': 'Sitting Area', 'value': '223' }, { 'label': 'Suite', 'value': '224' }]
  }, { 'label': 'Suite', 'value': '225' }]
}, {
  'label': 'Activity Tags',
  'value': 'parent-226',
  'children': [{ 'label': 'Activities (General)', 'value': '227' }, {
    'label': 'Entertainment',
    'value': 'parent-228',
    'children': [{ 'label': 'Band', 'value': '229' }, { 'label': 'Cinema', 'value': '230' }, {
      'label': 'Comedy',
      'value': '231'
    }, { 'label': 'Disc Jockey', 'value': '232' }, { 'label': 'Nightclub', 'value': '233' }, {
      'label': 'Theater Show',
      'value': '234'
    }]
  }, {
    'label': 'Interests',
    'value': 'parent-235',
    'children': [{ 'label': 'Adventure Travel', 'value': '236' }, {
      'label': 'Amusement Parks',
      'value': '237'
    }, { 'label': 'Architecture', 'value': '238' }, {
      'label': 'Arts and Entertainment',
      'value': '239'
    }, { 'label': 'Bird watching', 'value': '240' }, {
      'label': 'College Visits',
      'value': '241'
    }, { 'label': 'Computers/Internet/Social Media', 'value': '242' }, {
      'label': 'Cooking and Culinary',
      'value': '243'
    }, { 'label': 'Ecotourism', 'value': '244' }, { 'label': 'Education', 'value': '245' }, {
      'label': 'Escape',
      'value': '246'
    }, { 'label': 'Experiential Travel', 'value': '247' }, {
      'label': 'Family Travel',
      'value': '248'
    }, { 'label': 'Gardening/Gardens', 'value': '249' }, {
      'label': 'Health and Well-being',
      'value': '250'
    }, { 'label': 'Historical Vacations', 'value': '251' }, {
      'label': 'Hot Air Ballooning',
      'value': '252'
    }, { 'label': 'Luxury Travel', 'value': '253' }, {
      'label': 'Mountain Vacations',
      'value': '254'
    }, { 'label': 'Museums', 'value': '255' }, { 'label': 'Music', 'value': '256' }, {
      'label': 'National Parks',
      'value': '257'
    }, { 'label': 'Other', 'value': '258' }, { 'label': 'Photography', 'value': '259' }, {
      'label': 'Pop Culture',
      'value': '260'
    }, { 'label': 'Road Trips', 'value': '261' }, {
      'label': 'Romantic Getaways',
      'value': '262'
    }, { 'label': 'Shopping', 'value': '263' }, {
      'label': 'Single Parent Travel',
      'value': '264'
    }, { 'label': 'Whale Watching', 'value': '265' }, { 'label': 'Vineyards', 'value': '266' }]
  }, {
    'label': 'Local Area/Attractions',
    'value': 'parent-267',
    'children': [{ 'label': 'Bar', 'value': '268' }, {
      'label': 'Bar - Sports Bar',
      'value': '269'
    }, { 'label': 'Beach', 'value': '270' }, { 'label': 'Casino', 'value': '271' }, {
      'label': 'City',
      'value': '272'
    }, { 'label': 'Landmark', 'value': '273' }, { 'label': 'Local Attraction', 'value': '274' }, {
      'label': 'Mountains',
      'value': '275'
    }, { 'label': 'Ocean', 'value': '276' }, { 'label': 'River', 'value': '277' }, {
      'label': 'Riverwalk',
      'value': '278'
    }, { 'label': 'Skyline', 'value': '279' }, {
      'label': 'Sports Stadium',
      'value': 'parent-280',
      'children': [{ 'label': 'Auto Racing', 'value': '281' }, {
        'label': 'Baseball',
        'value': '282'
      }, { 'label': 'Basketball', 'value': '283' }, { 'label': 'Cricket', 'value': '284' }, {
        'label': 'Football',
        'value': '285'
      }, { 'label': 'Hockey', 'value': '286' }, { 'label': 'Horse Racing', 'value': '287' }, {
        'label': 'Olympic',
        'value': '288'
      }, { 'label': 'Rugby', 'value': '289' }, { 'label': 'Soccer', 'value': '290' }]
    }, { 'label': 'Waterfront', 'value': '291' }]
  }, {
    'label': 'Recreation',
    'value': 'parent-292',
    'children': [{ 'label': 'Bowling', 'value': '293' }, { 'label': 'Cycling', 'value': '294' }, {
      'label': 'Dancing',
      'value': '295'
    }, { 'label': 'Fitness Center', 'value': '296' }, {
      'label': 'Game room',
      'value': 'parent-297',
      'children': [{ 'label': 'Arcade', 'value': '298' }, { 'label': 'Billiards', 'value': '299' }, {
        'label': 'Darts',
        'value': '300'
      }, { 'label': 'Ping-pong', 'value': '301' }]
    }, {
      'label': 'Golf',
      'value': 'parent-302',
      'children': [{ 'label': 'Club House', 'value': '303' }, {
        'label': 'Driving Range',
        'value': '304'
      }, { 'label': 'Golf Course', 'value': '305' }, {
        'label': 'Golf Course Feature',
        'value': '306'
      }, { 'label': 'Golf School', 'value': '307' }, {
        'label': 'Mini Golf',
        'value': '308'
      }, { 'label': 'Putting Green', 'value': '309' }, { 'label': 'Pro Shop', 'value': '310' }]
    }, { 'label': 'Hiking', 'value': '311' }, { 'label': 'Horseback Riding', 'value': '312' }, {
      'label': 'Karaoke',
      'value': '313'
    }, { 'label': 'Kids\' club', 'value': '314' }, {
      'label': 'Park/Playground',
      'value': '315'
    }, {
      'label': 'Pool/Swimming',
      'value': 'parent-316',
      'children': [{ 'label': 'Children\'s Pool', 'value': '317' }, {
        'label': 'Indoor Pool',
        'value': '318'
      }, { 'label': 'Outdoor Pool', 'value': '319' }, {
        'label': 'Infinity Pool',
        'value': '320'
      }, { 'label': 'Waterfall', 'value': '321' }, { 'label': 'Waterslide', 'value': '322' }, {
        'label': 'Wave Pool',
        'value': '323'
      }]
    }, { 'label': 'Pro Shop', 'value': '324' }, {
      'label': 'Recreational Facility',
      'value': '325'
    }, { 'label': 'Rock Climbing', 'value': '326' }, {
      'label': 'Rock Climbing Wall',
      'value': '327'
    }, { 'label': 'Sports Clinic', 'value': '328' }, {
      'label': 'Sports Courts/Fields',
      'value': 'parent-329',
      'children': [{ 'label': 'Baseball', 'value': '330' }, {
        'label': 'Basketball',
        'value': '331'
      }, { 'label': 'Bocce', 'value': '332' }, { 'label': 'Football', 'value': '333' }, {
        'label': 'Soccer',
        'value': '334'
      }, { 'label': 'Squash', 'value': '335' }, { 'label': 'Tennis', 'value': '336' }, {
        'label': 'Volleyball',
        'value': '337'
      }]
    }, {
      'label': 'Water Sports/Recreation',
      'value': 'parent-338',
      'children': [{ 'label': 'Boating', 'value': '339' }, { 'label': 'Canoeing', 'value': '340' }, {
        'label': 'Dock',
        'value': '341'
      }, { 'label': 'Fishing', 'value': '342' }, { 'label': 'Kayaking', 'value': '343' }, {
        'label': 'Rafting',
        'value': '344'
      }, { 'label': 'Marina', 'value': '345' }, { 'label': 'Sailing', 'value': '346' }, {
        'label': 'Scuba Diving',
        'value': '347'
      }, { 'label': 'Snorkeling', 'value': '348' }, { 'label': 'Surfing', 'value': '349' }, {
        'label': 'Surfing Pool',
        'value': '350'
      }, { 'label': 'Water park', 'value': '351' }, {
        'label': 'Water skiing',
        'value': '352'
      }, { 'label': 'Windsurfing', 'value': '353' }]
    }, {
      'label': 'Winter/Ice Sports',
      'value': 'parent-354',
      'children': [{ 'label': 'Hockey', 'value': '355' }, {
        'label': 'Ice Skating',
        'value': '356'
      }, { 'label': 'Snow Skiing', 'value': '357' }, { 'label': 'Snowmobiling', 'value': '358' }]
    }, { 'label': 'Yoga', 'value': '359' }, { 'label': 'Zip lining', 'value': '360' }]
  }]
}, {
  'label': 'Supplemental Tags',
  'value': 'parent-361',
  'children': [{ 'label': 'Animals', 'value': '362' }, {
    'label': 'Location',
    'value': 'parent-363',
    'children': [{ 'label': 'Beachside', 'value': '364' }, {
      'label': 'Common area',
      'value': '365'
    }, { 'label': 'Indoor/Interior', 'value': '366' }, { 'label': 'In-Pool', 'value': '367' }, {
      'label': 'In-room',
      'value': '368'
    }, { 'label': 'Off-Site', 'value': '369' }, { 'label': 'On-Site', 'value': '370' }, {
      'label': 'Outdoor/Exterior',
      'value': '371'
    }, { 'label': 'Poolside', 'value': '372' }, { 'label': 'Roof', 'value': '374' }]
  }, { 'label': 'Miscellaneous', 'value': '375' }, {
    'label': 'People',
    'value': 'parent-376',
    'children': [{ 'label': 'Accessibility', 'value': '377' }, {
      'label': 'Adults',
      'value': 'parent-378',
      'children': [{ 'label': 'Middle age', 'value': '379' }, {
        'label': 'Over 65',
        'value': '380'
      }, { 'label': 'Young Adults', 'value': '381' }]
    }, { 'label': 'Businessmen/women', 'value': '382' }, {
      'label': 'Children',
      'value': 'parent-383',
      'children': [{ 'label': 'Infants', 'value': '384' }, {
        'label': 'Teenagers',
        'value': '385'
      }, { 'label': 'Young Children', 'value': '386' }]
    }, {
      'label': 'Ethnicity',
      'value': 'parent-387',
      'children': [{ 'label': 'Asian/Pacific Islander', 'value': '388' }, {
        'label': 'Black/African',
        'value': '389'
      }, { 'label': 'Hispanic', 'value': '390' }, { 'label': 'Other', 'value': '391' }, {
        'label': 'White/Caucasian',
        'value': '392'
      }]
    }, { 'label': 'Family', 'value': '393' }, { 'label': 'Guests', 'value': '394' }, {
      'label': 'Group',
      'value': '395'
    }, {
      'label': 'Marital Status',
      'value': 'parent-396',
      'children': [{ 'label': 'Couple', 'value': '397' }, { 'label': 'Divorced', 'value': '398' }, {
        'label': 'Engaged',
        'value': '399'
      }, { 'label': 'Expecting Parents', 'value': '400' }, {
        'label': 'Honeymooning',
        'value': '401'
      }, { 'label': 'LGBT', 'value': '402' }, { 'label': 'Married', 'value': '403' }, {
        'label': 'Other',
        'value': '404'
      }, { 'label': 'Single', 'value': '405' }, { 'label': 'Single Parent', 'value': '406' }]
    }, { 'label': 'Social group', 'value': '407' }, { 'label': 'Staff', 'value': '408' }, {
      'label': 'Sex – Female',
      'value': '409'
    }, { 'label': 'Sex – Male', 'value': '410' }]
  }, {
    'label': 'Photo Style',
    'value': 'parent-411',
    'children': [{
      'label': 'Aspect Ratio',
      'value': 'parent-412',
      'children': [{ 'label': 'Landscape (wide)', 'value': '413' }, {
        'label': 'Panorama (extra wide)',
        'value': '414'
      }, { 'label': 'Portrait (tall)', 'value': '415' }, { 'label': 'Square', 'value': '416' }]
    }, { 'label': 'Close-up', 'value': '417' }, {
      'label': 'Drawing/Illustration',
      'value': '418'
    }, { 'label': 'Floor Plan', 'value': '419' }, { 'label': 'Map', 'value': '420' }, {
      'label': 'Monochrome',
      'value': '421'
    }, { 'label': 'Rendering/CGI', 'value': '422' }, { 'label': 'Text Overlay', 'value': '423' }]
  }, {
    'label': 'Time of Day',
    'value': 'parent-424',
    'children': [{ 'label': 'Dawn/Sunrise', 'value': '425' }, {
      'label': 'Day',
      'value': '426'
    }, { 'label': 'Dusk/Sunset', 'value': '427' }, { 'label': 'Evening/Night', 'value': '428' }]
  }, {
    'label': 'Time of Year',
    'value': 'parent-429',
    'children': [{
      'label': 'Holiday',
      'value': 'parent-430',
      'children': [{ 'label': 'Christmas', 'value': '431' }, {
        'label': 'New Year\'s',
        'value': '432'
      }, { 'label': 'Valentine\'s Day', 'value': '433' }]
    }, {
      'label': 'Season',
      'value': 'parent-434',
      'children': [{ 'label': 'Autumn', 'value': '435' }, { 'label': 'Spring', 'value': '436' }, {
        'label': 'Summer',
        'value': '437'
      }, { 'label': 'Winter', 'value': '438' }]
    }]
  }, {
    'label': 'View From',
    'value': 'parent-439',
    'children': [{ 'label': 'Above', 'value': '440' }, { 'label': 'Back', 'value': '441' }, {
      'label': 'Balcony',
      'value': '442'
    }, { 'label': 'Front', 'value': '443' }, { 'label': 'Guest Room', 'value': '444' }, {
      'label': 'Property',
      'value': '445'
    }, { 'label': 'Rooftop', 'value': '446' }, { 'label': 'Satellite', 'value': '447' }, {
      'label': 'Street',
      'value': '448'
    }]
  }]
}]

export const tagIds2NodeIds = {
  '1': '117',
  '2': '116',
  '4': '118',
  '5': '119',
  '6': '48',
  '8': '50',
  '9': '51',
  '10': '52',
  '11': '53',
  '12': '54',
  '13': '55',
  '14': '56',
  '15': '57',
  '16': '58',
  '18': '60',
  '19': '61',
  '20': '62',
  '21': '64',
  '22': '65',
  '23': '66',
  '24': '67',
  '26': '71',
  '27': '74',
  '28': '72',
  '29': '75',
  '30': '78',
  '31': '59',
  '32': '80',
  '33': '81',
  '34': '185',
  '35': '188',
  '36': '168',
  '37': '169',
  '38': '170',
  '39': '171',
  '40': '172',
  '41': '173',
  '42': '174',
  '43': '175',
  '44': '176',
  '45': '177',
  '46': '178',
  '47': '181',
  '48': '182',
  '49': '184',
  '50': '187',
  '51': '189',
  '52': '180',
  '53': '191',
  '55': '141',
  '56': '194',
  '57': '198',
  '58': '199',
  '59': '202',
  '60': '203',
  '61': '205',
  '62': '113',
  '63': '197',
  '64': '206',
  '65': '148',
  '66': '122',
  '67': '127',
  '68': '111',
  '69': '224',
  '71': '210',
  '72': '212',
  '74': '236',
  '75': '237',
  '76': '238',
  '77': '239',
  '78': '240',
  '79': '241',
  '80': '242',
  '81': '243',
  '82': '244',
  '83': '245',
  '84': '246',
  '85': '247',
  '86': '248',
  '87': '249',
  '88': '250',
  '89': '251',
  '90': '252',
  '91': '253',
  '92': '254',
  '93': '255',
  '94': '256',
  '95': '257',
  '96': '259',
  '97': '260',
  '98': '261',
  '99': '262',
  '100': '263',
  '101': '264',
  '102': '265',
  '103': '266',
  '105': '364',
  '106': '365',
  '107': '366',
  '108': '368',
  '109': '420',
  '110': '369',
  '111': '370',
  '113': '371',
  '114': '372',
  '115': '267',
  '116': '272',
  '117': '273',
  '118': '274',
  '119': '275',
  '120': '276',
  '121': '277',
  '122': '9',
  '123': '20',
  '124': '21',
  '125': '22',
  '126': '10',
  '127': '23',
  '128': '11',
  '129': '12',
  '130': '13',
  '131': '14',
  '132': '15',
  '133': '16',
  '134': '17',
  '135': '24',
  '136': '25',
  '137': '19',
  '138': '46',
  '140': '27',
  '141': '28',
  '142': '29',
  '143': '30',
  '144': '31',
  '145': '32',
  '146': '33',
  '147': '34',
  '148': '35',
  '149': '36',
  '150': '37',
  '151': '38',
  '152': '39',
  '153': '40',
  '154': '41',
  '155': '42',
  '156': '43',
  '157': '44',
  '158': '45',
  '159': '376',
  '160': '378',
  '161': '379',
  '162': '380',
  '163': '381',
  '164': '382',
  '165': '383',
  '166': '384',
  '167': '385',
  '168': '386',
  '170': '388',
  '171': '389',
  '172': '390',
  '173': '391',
  '174': '392',
  '175': '393',
  '177': '397',
  '178': '398',
  '179': '399',
  '180': '400',
  '181': '402',
  '182': '403',
  '183': '404',
  '184': '405',
  '185': '406',
  '186': '407',
  '187': '408',
  '189': '409',
  '190': '410',
  '192': '136',
  '193': '106',
  '195': '2',
  '197': '3',
  '198': '138',
  '199': '107',
  '200': '139',
  '201': '140',
  '202': '108',
  '203': '83',
  '204': '114',
  '205': '84',
  '208': '142',
  '209': '86',
  '210': '87',
  '211': '143',
  '212': '88',
  '213': '115',
  '215': '89',
  '216': '144',
  '217': '145',
  '218': '105',
  '219': '112',
  '220': '90',
  '221': '120',
  '224': '110',
  '227': '124',
  '228': '91',
  '229': '125',
  '230': '126',
  '231': '76',
  '232': '292',
  '233': '299',
  '234': '293',
  '235': '137',
  '236': '300',
  '237': '294',
  '238': '295',
  '239': '228',
  '240': '229',
  '241': '230',
  '242': '231',
  '243': '232',
  '244': '233',
  '245': '234',
  '247': '104',
  '248': '359',
  '249': '297',
  '250': '302',
  '251': '303',
  '252': '304',
  '253': '305',
  '254': '306',
  '255': '307',
  '256': '308',
  '257': '310',
  '258': '311',
  '259': '312',
  '260': '313',
  '261': '314',
  '263': '315',
  '264': '301',
  '266': '325',
  '268': '326',
  '271': '335',
  '276': '130',
  '277': '133',
  '278': '134',
  '280': '282',
  '281': '285',
  '282': '286',
  '283': '290',
  '284': '337',
  '285': '336',
  '286': '338',
  '287': '339',
  '288': '340',
  '289': '342',
  '290': '343',
  '291': '344',
  '292': '345',
  '293': '346',
  '294': '347',
  '295': '348',
  '296': '349',
  '297': '350',
  '298': '351',
  '299': '352',
  '300': '353',
  '301': '354',
  '303': '356',
  '304': '357',
  '305': '77',
  '306': '360',
  '307': '152',
  '308': '153',
  '309': '154',
  '310': '156',
  '311': '157',
  '312': '161',
  '313': '162',
  '314': '163',
  '315': '164',
  '319': '6',
  '320': '8',
  '321': '5',
  '322': '7',
  '324': '436',
  '325': '437',
  '326': '435',
  '327': '438',
  '328': '430',
  '329': '432',
  '330': '433',
  '331': '431',
  '333': '99',
  '334': '100',
  '335': '442',
  '336': '101',
  '337': '444',
  '338': '445',
  '339': '446',
  '340': '103',
  '341': '195',
  '342': '204',
  '344': '214',
  '345': '215',
  '346': '216',
  '347': '217',
  '348': '218',
  '349': '219',
  '350': '220',
  '351': '221',
  '352': '222',
  '353': '278',
  '354': '279',
  '355': '291',
  '356': '374',
  '357': '18',
  '358': '47',
  '360': '421',
  '361': '417',
  '363': '413',
  '364': '414',
  '365': '415',
  '366': '416',
  '368': '341',
  '369': '102',
  '370': '158',
  '372': '147',
  '374': '123',
  '377': '419',
  '379': '85',
  '380': '298',
  '381': '281',
  '382': '283',
  '383': '179',
  '384': '183',
  '385': '332',
  '386': '82',
  '387': '329',
  '388': '284',
  '389': '63',
  '390': '287',
  '391': '155',
  '392': '258',
  '393': '146',
  '394': '401',
  '395': '288',
  '396': '135',
  '397': '418',
  '398': '422',
  '399': '423',
  '400': '309',
  '401': '327',
  '402': '289',
  '403': '26',
  '404': '358',
  '405': '151',
  '406': '280',
  '407': '211',
  '408': '227',
  '409': '362',
  '410': '73',
  '411': '186',
  '412': '394',
  '413': '269',
  '414': '69',
  '416': '367',
  '418': '121',
  '419': '131',
  '420': '159',
  '421': '160',
  '422': '149',
  '423': '165',
  '424': '92',
  '425': '70',
  '426': '395',
  '427': '150'
}
export const nodeIdsAddInfo = {
  '1': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '0', 'label': 'Property Tags' },
  '2': { 'autoSelectTagIds': '111', 'tagID': '195', 'parentNodeId': '1', 'label': 'Bar' },
  '3': { 'autoSelectTagIds': '111', 'tagID': '197', 'parentNodeId': '1', 'label': 'Beach' },
  '4': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '3', 'label': 'Time of Day' },
  '5': { 'autoSelectTagIds': '', 'tagID': '321', 'parentNodeId': '4', 'label': 'Dawn/Sunrise' },
  '6': { 'autoSelectTagIds': '', 'tagID': '319', 'parentNodeId': '4', 'label': 'Day' },
  '7': { 'autoSelectTagIds': '', 'tagID': '322', 'parentNodeId': '4', 'label': 'Dusk/Sunset' },
  '8': { 'autoSelectTagIds': '', 'tagID': '320', 'parentNodeId': '4', 'label': 'Evening/Night' },
  '9': { 'autoSelectTagIds': '', 'tagID': '122', 'parentNodeId': '1', 'label': 'Business/Events' },
  '10': { 'autoSelectTagIds': '111,122', 'tagID': '126', 'parentNodeId': '9', 'label': 'Business Services/Center' },
  '11': { 'autoSelectTagIds': '122', 'tagID': '128', 'parentNodeId': '9', 'label': 'Event' },
  '12': { 'autoSelectTagIds': '128,122', 'tagID': '129', 'parentNodeId': '11', 'label': 'Banquet' },
  '13': { 'autoSelectTagIds': '128,122', 'tagID': '130', 'parentNodeId': '11', 'label': 'Conference' },
  '14': { 'autoSelectTagIds': '128,122', 'tagID': '131', 'parentNodeId': '11', 'label': 'Exhibition' },
  '15': { 'autoSelectTagIds': '128,122', 'tagID': '132', 'parentNodeId': '11', 'label': 'Group Event' },
  '16': { 'autoSelectTagIds': '128,122', 'tagID': '133', 'parentNodeId': '11', 'label': 'Trade Show/Conference' },
  '17': { 'autoSelectTagIds': '128,122', 'tagID': '134', 'parentNodeId': '11', 'label': 'Wedding' },
  '18': { 'autoSelectTagIds': '', 'tagID': '357', 'parentNodeId': '9', 'label': 'Fax' },
  '19': { 'autoSelectTagIds': '122,111', 'tagID': '137', 'parentNodeId': '9', 'label': 'Meeting Room' },
  '20': { 'autoSelectTagIds': '137,122,111', 'tagID': '123', 'parentNodeId': '19', 'label': 'Auditorium/Amphitheater' },
  '21': { 'autoSelectTagIds': '137,122,111', 'tagID': '124', 'parentNodeId': '19', 'label': 'Ballroom' },
  '22': { 'autoSelectTagIds': '137,122,111', 'tagID': '125', 'parentNodeId': '19', 'label': 'Boardroom' },
  '23': { 'autoSelectTagIds': '137,122,111', 'tagID': '127', 'parentNodeId': '19', 'label': 'Conference Room' },
  '24': { 'autoSelectTagIds': '137,122,111', 'tagID': '135', 'parentNodeId': '19', 'label': 'Meeting Facilities' },
  '25': { 'autoSelectTagIds': '137,122,111', 'tagID': '136', 'parentNodeId': '19', 'label': 'Meeting Reception' },
  '26': { 'autoSelectTagIds': '137,122,111', 'tagID': '403', 'parentNodeId': '19', 'label': 'Seating' },
  '27': { 'autoSelectTagIds': '137,122,111', 'tagID': '140', 'parentNodeId': '26', 'label': 'Cabaret' },
  '28': { 'autoSelectTagIds': '137,122,111', 'tagID': '141', 'parentNodeId': '26', 'label': 'Chevron' },
  '29': { 'autoSelectTagIds': '137,122,111', 'tagID': '142', 'parentNodeId': '26', 'label': 'Circle of Chairs' },
  '30': { 'autoSelectTagIds': '137,122,111', 'tagID': '143', 'parentNodeId': '26', 'label': 'Classroom' },
  '31': { 'autoSelectTagIds': '137,122,111', 'tagID': '144', 'parentNodeId': '26', 'label': 'Clusters' },
  '32': { 'autoSelectTagIds': '137,122,111', 'tagID': '145', 'parentNodeId': '26', 'label': 'Cocktail' },
  '33': { 'autoSelectTagIds': '137,122,111', 'tagID': '146', 'parentNodeId': '26', 'label': 'Crescent Rounds' },
  '34': { 'autoSelectTagIds': '137,122,111', 'tagID': '147', 'parentNodeId': '26', 'label': 'Dancefloor and Staging' },
  '35': { 'autoSelectTagIds': '137,122,111', 'tagID': '148', 'parentNodeId': '26', 'label': 'Double U' },
  '36': { 'autoSelectTagIds': '137,122,111', 'tagID': '149', 'parentNodeId': '26', 'label': 'Empty' },
  '37': {
    'autoSelectTagIds': '137,122,111',
    'tagID': '150',
    'parentNodeId': '26',
    'label': 'Exhibit Hall with Booths'
  },
  '38': { 'autoSelectTagIds': '137,122,111', 'tagID': '151', 'parentNodeId': '26', 'label': 'General Session' },
  '39': { 'autoSelectTagIds': '137,122,111', 'tagID': '152', 'parentNodeId': '26', 'label': 'Highboys' },
  '40': { 'autoSelectTagIds': '137,122,111', 'tagID': '153', 'parentNodeId': '26', 'label': 'Hollow Square Style' },
  '41': { 'autoSelectTagIds': '137,122,111', 'tagID': '154', 'parentNodeId': '26', 'label': 'Imperial' },
  '42': { 'autoSelectTagIds': '137,122,111', 'tagID': '155', 'parentNodeId': '26', 'label': 'Rounds' },
  '43': { 'autoSelectTagIds': '137,122,111', 'tagID': '156', 'parentNodeId': '26', 'label': 'Theater' },
  '44': { 'autoSelectTagIds': '137,122,111', 'tagID': '157', 'parentNodeId': '26', 'label': 'Theater in the Round' },
  '45': { 'autoSelectTagIds': '137,122,111', 'tagID': '158', 'parentNodeId': '26', 'label': 'U Shape' },
  '46': { 'autoSelectTagIds': '111', 'tagID': '138', 'parentNodeId': '9', 'label': 'Office' },
  '47': { 'autoSelectTagIds': '', 'tagID': '358', 'parentNodeId': '9', 'label': 'Printer' },
  '48': { 'autoSelectTagIds': '', 'tagID': '6', 'parentNodeId': '1', 'label': 'Dining' },
  '49': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '48', 'label': 'Cuisine' },
  '50': { 'autoSelectTagIds': '6', 'tagID': '8', 'parentNodeId': '49', 'label': 'American' },
  '51': { 'autoSelectTagIds': '6', 'tagID': '9', 'parentNodeId': '49', 'label': 'Asian' },
  '52': { 'autoSelectTagIds': '6', 'tagID': '10', 'parentNodeId': '49', 'label': 'Continental' },
  '53': { 'autoSelectTagIds': '6', 'tagID': '11', 'parentNodeId': '49', 'label': 'English/Irish' },
  '54': { 'autoSelectTagIds': '6', 'tagID': '12', 'parentNodeId': '49', 'label': 'French' },
  '55': { 'autoSelectTagIds': '6', 'tagID': '13', 'parentNodeId': '49', 'label': 'Indian' },
  '56': { 'autoSelectTagIds': '6', 'tagID': '14', 'parentNodeId': '49', 'label': 'Italian' },
  '57': { 'autoSelectTagIds': '6,111', 'tagID': '15', 'parentNodeId': '48', 'label': 'Dining Area' },
  '58': { 'autoSelectTagIds': '15,6,111', 'tagID': '16', 'parentNodeId': '57', 'label': 'BBQ/Picnic Area' },
  '59': { 'autoSelectTagIds': '15,6,111', 'tagID': '31', 'parentNodeId': '57', 'label': 'Breakfast Area' },
  '60': { 'autoSelectTagIds': '15,6,111', 'tagID': '18', 'parentNodeId': '57', 'label': 'Buffet' },
  '61': { 'autoSelectTagIds': '15,6,111', 'tagID': '19', 'parentNodeId': '57', 'label': 'Café' },
  '62': { 'autoSelectTagIds': '15,6,111', 'tagID': '20', 'parentNodeId': '57', 'label': 'Coffee shop' },
  '63': { 'autoSelectTagIds': '15,6,111', 'tagID': '389', 'parentNodeId': '57', 'label': 'Food Court' },
  '64': { 'autoSelectTagIds': '15,6,111', 'tagID': '21', 'parentNodeId': '57', 'label': 'Grill/Pub' },
  '65': { 'autoSelectTagIds': '15,6,111', 'tagID': '22', 'parentNodeId': '57', 'label': 'Restaurant' },
  '66': { 'autoSelectTagIds': '22,15,6,111', 'tagID': '23', 'parentNodeId': '57', 'label': 'Restaurant Feature' },
  '67': { 'autoSelectTagIds': '15,6,111', 'tagID': '24', 'parentNodeId': '57', 'label': 'Snack Bar' },
  '68': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '48', 'label': 'Food/Drink' },
  '69': { 'autoSelectTagIds': '', 'tagID': '414', 'parentNodeId': '68', 'label': 'Coffee Service' },
  '70': { 'autoSelectTagIds': '', 'tagID': '425', 'parentNodeId': '68', 'label': 'Drink' },
  '71': { 'autoSelectTagIds': '425', 'tagID': '26', 'parentNodeId': '68', 'label': 'Drink - Alcoholic' },
  '72': { 'autoSelectTagIds': '425', 'tagID': '28', 'parentNodeId': '68', 'label': 'Drink - Non-Alcoholic' },
  '73': { 'autoSelectTagIds': '', 'tagID': '410', 'parentNodeId': '68', 'label': 'Food' },
  '74': { 'autoSelectTagIds': '', 'tagID': '27', 'parentNodeId': '68', 'label': 'Grocery store/supermarket' },
  '75': { 'autoSelectTagIds': '425,26', 'tagID': '29', 'parentNodeId': '68', 'label': 'Wine' },
  '76': { 'autoSelectTagIds': '425,26', 'tagID': '231', 'parentNodeId': '68', 'label': 'Wine Cellar' },
  '77': { 'autoSelectTagIds': '425,26', 'tagID': '305', 'parentNodeId': '68', 'label': 'Wine Tasting' },
  '78': { 'autoSelectTagIds': '6', 'tagID': '30', 'parentNodeId': '48', 'label': 'Meals' },
  '79': { 'autoSelectTagIds': '30,6', 'tagID': '31', 'parentNodeId': '78', 'label': 'Breakfast' },
  '80': { 'autoSelectTagIds': '30,6', 'tagID': '32', 'parentNodeId': '78', 'label': 'Dinner' },
  '81': { 'autoSelectTagIds': '30,6', 'tagID': '33', 'parentNodeId': '78', 'label': 'Lunch' },
  '82': { 'autoSelectTagIds': '113,111', 'tagID': '386', 'parentNodeId': '1', 'label': 'Exterior View of Building' },
  '83': { 'autoSelectTagIds': '113,111', 'tagID': '203', 'parentNodeId': '82', 'label': 'Courtyard' },
  '84': { 'autoSelectTagIds': '113,111', 'tagID': '205', 'parentNodeId': '82', 'label': 'Entrance' },
  '85': { 'autoSelectTagIds': '113,111', 'tagID': '379', 'parentNodeId': '82', 'label': 'Featured View' },
  '86': { 'autoSelectTagIds': '113,111', 'tagID': '209', 'parentNodeId': '82', 'label': 'Garden' },
  '87': { 'autoSelectTagIds': '113,111', 'tagID': '210', 'parentNodeId': '82', 'label': 'Gazebo' },
  '88': { 'autoSelectTagIds': '113,111', 'tagID': '212', 'parentNodeId': '82', 'label': 'Grounds' },
  '89': { 'autoSelectTagIds': '113,111', 'tagID': '215', 'parentNodeId': '82', 'label': 'Lake' },
  '90': { 'autoSelectTagIds': '113,111', 'tagID': '220', 'parentNodeId': '82', 'label': 'Natural landscape' },
  '91': { 'autoSelectTagIds': '113,111', 'tagID': '228', 'parentNodeId': '82', 'label': 'Street' },
  '92': { 'autoSelectTagIds': '113,111', 'tagID': '424', 'parentNodeId': '82', 'label': 'Sundeck' },
  '93': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '82', 'label': 'Time of Day' },
  '94': { 'autoSelectTagIds': '', 'tagID': '321', 'parentNodeId': '93', 'label': 'Dawn/Sunrise' },
  '95': { 'autoSelectTagIds': '', 'tagID': '319', 'parentNodeId': '93', 'label': 'Day' },
  '96': { 'autoSelectTagIds': '', 'tagID': '322', 'parentNodeId': '93', 'label': 'Dusk/Sunset' },
  '97': { 'autoSelectTagIds': '', 'tagID': '320', 'parentNodeId': '93', 'label': 'Evening/Night' },
  '98': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '82', 'label': 'View From' },
  '99': { 'autoSelectTagIds': '', 'tagID': '333', 'parentNodeId': '98', 'label': 'Above' },
  '100': { 'autoSelectTagIds': '', 'tagID': '334', 'parentNodeId': '98', 'label': 'Back' },
  '101': { 'autoSelectTagIds': '', 'tagID': '336', 'parentNodeId': '98', 'label': 'Front' },
  '102': { 'autoSelectTagIds': '', 'tagID': '369', 'parentNodeId': '98', 'label': 'Satellite' },
  '103': { 'autoSelectTagIds': '', 'tagID': '340', 'parentNodeId': '98', 'label': 'Street' },
  '104': { 'autoSelectTagIds': '192,111', 'tagID': '247', 'parentNodeId': '1', 'label': 'Fitness Center' },
  '105': { 'autoSelectTagIds': '111', 'tagID': '218', 'parentNodeId': '1', 'label': 'Lobby' },
  '106': { 'autoSelectTagIds': '111', 'tagID': '193', 'parentNodeId': '105', 'label': 'Atrium' },
  '107': { 'autoSelectTagIds': '111', 'tagID': '199', 'parentNodeId': '105', 'label': 'Check-in/out Kiosk' },
  '108': { 'autoSelectTagIds': '111', 'tagID': '202', 'parentNodeId': '105', 'label': 'Concierge' },
  '109': { 'autoSelectTagIds': '111', 'tagID': '205', 'parentNodeId': '105', 'label': 'Entrance' },
  '110': { 'autoSelectTagIds': '218,111', 'tagID': '224', 'parentNodeId': '105', 'label': 'Reception' },
  '111': { 'autoSelectTagIds': '111', 'tagID': '68', 'parentNodeId': '105', 'label': 'Sitting area' },
  '112': { 'autoSelectTagIds': '111', 'tagID': '219', 'parentNodeId': '1', 'label': 'Miscellaneous' },
  '113': { 'autoSelectTagIds': '111', 'tagID': '62', 'parentNodeId': '112', 'label': 'Accessibility' },
  '114': { 'autoSelectTagIds': '111', 'tagID': '204', 'parentNodeId': '112', 'label': 'Décor detail' },
  '115': { 'autoSelectTagIds': '111', 'tagID': '213', 'parentNodeId': '112', 'label': 'Hallway' },
  '116': { 'autoSelectTagIds': '397', 'tagID': '2', 'parentNodeId': '112', 'label': 'Logo' },
  '117': { 'autoSelectTagIds': '2,397', 'tagID': '1', 'parentNodeId': '116', 'label': 'Brand Logo' },
  '118': { 'autoSelectTagIds': '2', 'tagID': '4', 'parentNodeId': '116', 'label': 'Certificate/award' },
  '119': { 'autoSelectTagIds': '2', 'tagID': '5', 'parentNodeId': '116', 'label': 'Property logo or sign' },
  '120': { 'autoSelectTagIds': '111', 'tagID': '221', 'parentNodeId': '112', 'label': 'Parking' },
  '121': { 'autoSelectTagIds': '111', 'tagID': '418', 'parentNodeId': '112', 'label': 'Parking - RV/Truck' },
  '122': { 'autoSelectTagIds': '', 'tagID': '66', 'parentNodeId': '112', 'label': 'Pets' },
  '123': { 'autoSelectTagIds': '', 'tagID': '374', 'parentNodeId': '112', 'label': 'Service' },
  '124': { 'autoSelectTagIds': '111', 'tagID': '227', 'parentNodeId': '112', 'label': 'Staircase' },
  '125': { 'autoSelectTagIds': '111', 'tagID': '229', 'parentNodeId': '112', 'label': 'Valet' },
  '126': { 'autoSelectTagIds': '111', 'tagID': '230', 'parentNodeId': '112', 'label': 'Vending machine' },
  '127': { 'autoSelectTagIds': '232,192,111', 'tagID': '67', 'parentNodeId': '1', 'label': 'Pool' },
  '128': { 'autoSelectTagIds': '165,232,192,111', 'tagID': '67', 'parentNodeId': '127', 'label': 'Children\'s Pool' },
  '129': { 'autoSelectTagIds': '107,232,192,111', 'tagID': '67', 'parentNodeId': '127', 'label': 'Indoor Pool' },
  '130': { 'autoSelectTagIds': '67,232,192,111', 'tagID': '276', 'parentNodeId': '127', 'label': 'Infinity Pool' },
  '131': { 'autoSelectTagIds': '67,232,192,111', 'tagID': '419', 'parentNodeId': '127', 'label': 'Lap Pool' },
  '132': { 'autoSelectTagIds': '113,232,192,111', 'tagID': '67', 'parentNodeId': '127', 'label': 'Outdoor Pool' },
  '133': { 'autoSelectTagIds': '192,111', 'tagID': '277', 'parentNodeId': '127', 'label': 'Waterfall' },
  '134': { 'autoSelectTagIds': '232,192,111', 'tagID': '278', 'parentNodeId': '127', 'label': 'Waterslide' },
  '135': { 'autoSelectTagIds': '67,232,192,111', 'tagID': '396', 'parentNodeId': '127', 'label': 'Wave Pool' },
  '136': { 'autoSelectTagIds': '111', 'tagID': '192', 'parentNodeId': '1', 'label': 'Property Amenity' },
  '137': { 'autoSelectTagIds': '192,111', 'tagID': '235', 'parentNodeId': '136', 'label': 'Casino' },
  '138': { 'autoSelectTagIds': '192,111', 'tagID': '198', 'parentNodeId': '136', 'label': 'Chapel/Place of worship' },
  '139': { 'autoSelectTagIds': '192,111', 'tagID': '200', 'parentNodeId': '136', 'label': 'Communal Kitchen' },
  '140': { 'autoSelectTagIds': '192,111', 'tagID': '201', 'parentNodeId': '136', 'label': 'Communal lounge/TV room' },
  '141': { 'autoSelectTagIds': '192,111', 'tagID': '55', 'parentNodeId': '136', 'label': 'Fireplace' },
  '142': { 'autoSelectTagIds': '192,111', 'tagID': '208', 'parentNodeId': '136', 'label': 'Fountain' },
  '143': { 'autoSelectTagIds': '192,111', 'tagID': '211', 'parentNodeId': '136', 'label': 'Gift Shop' },
  '144': { 'autoSelectTagIds': '192,111', 'tagID': '216', 'parentNodeId': '136', 'label': 'Laundry Facilities' },
  '145': { 'autoSelectTagIds': '192,111', 'tagID': '217', 'parentNodeId': '136', 'label': 'Library' },
  '146': {
    'autoSelectTagIds': '192,111',
    'tagID': '393',
    'parentNodeId': '136',
    'label': 'Loyalty Program Lounge/Floor'
  },
  '147': { 'autoSelectTagIds': '192,111', 'tagID': '372', 'parentNodeId': '136', 'label': 'Pantry/Convenience Store' },
  '148': { 'autoSelectTagIds': '192,111', 'tagID': '65', 'parentNodeId': '136', 'label': 'Patio/Terrace' },
  '149': { 'autoSelectTagIds': '192', 'tagID': '422', 'parentNodeId': '136', 'label': 'Shuttle - Airport/Seaport' },
  '150': { 'autoSelectTagIds': '192', 'tagID': '427', 'parentNodeId': '136', 'label': 'Shuttle - City/Other' },
  '151': { 'autoSelectTagIds': '192,111', 'tagID': '405', 'parentNodeId': '136', 'label': 'Solarium' },
  '152': { 'autoSelectTagIds': '192,111', 'tagID': '307', 'parentNodeId': '1', 'label': 'Spa' },
  '153': {
    'autoSelectTagIds': '307,192,111',
    'tagID': '308',
    'parentNodeId': '152',
    'label': 'Bathhouse/Turkish Bath'
  },
  '154': { 'autoSelectTagIds': '307,192,111', 'tagID': '309', 'parentNodeId': '152', 'label': 'Hot springs' },
  '155': { 'autoSelectTagIds': '307,192,111', 'tagID': '391', 'parentNodeId': '152', 'label': 'Hot Tub' },
  '156': { 'autoSelectTagIds': '307,192,111', 'tagID': '310', 'parentNodeId': '152', 'label': 'Massage' },
  '157': { 'autoSelectTagIds': '307,192,111', 'tagID': '311', 'parentNodeId': '152', 'label': 'Massage room' },
  '158': { 'autoSelectTagIds': '307,192,111', 'tagID': '370', 'parentNodeId': '152', 'label': 'Salon' },
  '159': { 'autoSelectTagIds': '307,192,111', 'tagID': '420', 'parentNodeId': '152', 'label': 'Salon - Hair' },
  '160': { 'autoSelectTagIds': '307,192,111', 'tagID': '421', 'parentNodeId': '152', 'label': 'Salon - Nail' },
  '161': { 'autoSelectTagIds': '307,192,111', 'tagID': '312', 'parentNodeId': '152', 'label': 'Sauna/Steam Room' },
  '162': { 'autoSelectTagIds': '307,192,111', 'tagID': '313', 'parentNodeId': '152', 'label': 'Spa Reception' },
  '163': { 'autoSelectTagIds': '307,192,111', 'tagID': '314', 'parentNodeId': '152', 'label': 'Spa Treatment' },
  '164': { 'autoSelectTagIds': '307,192,111', 'tagID': '315', 'parentNodeId': '152', 'label': 'Spa Treatment Room' },
  '165': { 'autoSelectTagIds': '307,192,111', 'tagID': '423', 'parentNodeId': '152', 'label': 'Steam Room' },
  '166': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '0', 'label': 'Guest Room Tags' },
  '167': { 'autoSelectTagIds': '34,111', 'tagID': '62', 'parentNodeId': '166', 'label': 'Accessibility' },
  '168': { 'autoSelectTagIds': '34,111', 'tagID': '36', 'parentNodeId': '166', 'label': 'Bathroom' },
  '169': { 'autoSelectTagIds': '36,34,111', 'tagID': '37', 'parentNodeId': '168', 'label': 'Amenities' },
  '170': { 'autoSelectTagIds': '36,34,111', 'tagID': '38', 'parentNodeId': '168', 'label': 'Shower' },
  '171': { 'autoSelectTagIds': '36,34,111', 'tagID': '39', 'parentNodeId': '168', 'label': 'Sink' },
  '172': { 'autoSelectTagIds': '36,34,111', 'tagID': '40', 'parentNodeId': '168', 'label': 'Toilet' },
  '173': { 'autoSelectTagIds': '36,34,111', 'tagID': '41', 'parentNodeId': '168', 'label': 'Tub' },
  '174': { 'autoSelectTagIds': '36,34,111', 'tagID': '42', 'parentNodeId': '168', 'label': 'Tub - Deep Soaking' },
  '175': { 'autoSelectTagIds': '36,34,111', 'tagID': '43', 'parentNodeId': '168', 'label': 'Tub - Jetted' },
  '176': { 'autoSelectTagIds': '34,111', 'tagID': '44', 'parentNodeId': '166', 'label': 'Bed' },
  '177': { 'autoSelectTagIds': '44,34,111', 'tagID': '45', 'parentNodeId': '176', 'label': 'Bedding' },
  '178': { 'autoSelectTagIds': '44,34,111', 'tagID': '46', 'parentNodeId': '176', 'label': 'Bunk bed' },
  '179': { 'autoSelectTagIds': '44,34,111', 'tagID': '383', 'parentNodeId': '176', 'label': 'Cot/Rollaway Bed' },
  '180': { 'autoSelectTagIds': '44,34,111', 'tagID': '52', 'parentNodeId': '176', 'label': 'Crib' },
  '181': { 'autoSelectTagIds': '44,34,111', 'tagID': '47', 'parentNodeId': '176', 'label': 'King bed' },
  '182': { 'autoSelectTagIds': '44,34,111', 'tagID': '48', 'parentNodeId': '176', 'label': 'Queen bed' },
  '183': { 'autoSelectTagIds': '44,34,111', 'tagID': '384', 'parentNodeId': '176', 'label': 'Sofabed' },
  '184': { 'autoSelectTagIds': '34,111', 'tagID': '49', 'parentNodeId': '166', 'label': 'Dining area' },
  '185': { 'autoSelectTagIds': '111', 'tagID': '34', 'parentNodeId': '166', 'label': 'Guest Room' },
  '186': { 'autoSelectTagIds': '111', 'tagID': '411', 'parentNodeId': '166', 'label': 'Guest Room - Whole Room' },
  '187': { 'autoSelectTagIds': '34', 'tagID': '50', 'parentNodeId': '166', 'label': 'Guest Room Amenity' },
  '188': { 'autoSelectTagIds': '50,34,111', 'tagID': '35', 'parentNodeId': '187', 'label': 'Balcony' },
  '189': { 'autoSelectTagIds': '50,34,111', 'tagID': '51', 'parentNodeId': '187', 'label': 'Business Facilities' },
  '190': { 'autoSelectTagIds': '50,34,111', 'tagID': '52', 'parentNodeId': '187', 'label': 'Crib' },
  '191': { 'autoSelectTagIds': '50,34,111', 'tagID': '53', 'parentNodeId': '187', 'label': 'Coffee/tea facilities' },
  '192': { 'autoSelectTagIds': '50,34,111', 'tagID': '204', 'parentNodeId': '187', 'label': 'Décor detail' },
  '193': { 'autoSelectTagIds': '50,34,111', 'tagID': '55', 'parentNodeId': '187', 'label': 'Fireplace' },
  '194': { 'autoSelectTagIds': '50,34,111', 'tagID': '56', 'parentNodeId': '187', 'label': 'Full Bar' },
  '195': { 'autoSelectTagIds': '50,34,111', 'tagID': '341', 'parentNodeId': '187', 'label': 'Furnishings' },
  '196': { 'autoSelectTagIds': '50,34,111', 'tagID': '391', 'parentNodeId': '187', 'label': 'Hot Tub' },
  '197': { 'autoSelectTagIds': '50,34,111', 'tagID': '63', 'parentNodeId': '187', 'label': 'Kitchen/Kitchenette' },
  '198': { 'autoSelectTagIds': '50,34,111', 'tagID': '57', 'parentNodeId': '187', 'label': 'Minibar' },
  '199': { 'autoSelectTagIds': '50,34,111', 'tagID': '58', 'parentNodeId': '187', 'label': 'Mini-Refrigerator' },
  '200': { 'autoSelectTagIds': '50,34,111', 'tagID': '65', 'parentNodeId': '187', 'label': 'Patio/Terrace' },
  '201': { 'autoSelectTagIds': '50,34,111', 'tagID': '67', 'parentNodeId': '187', 'label': 'Pool' },
  '202': { 'autoSelectTagIds': '50,34,111', 'tagID': '59', 'parentNodeId': '187', 'label': 'Refrigerator' },
  '203': { 'autoSelectTagIds': '50,34,111', 'tagID': '60', 'parentNodeId': '187', 'label': 'Safe' },
  '204': { 'autoSelectTagIds': '50,34,111', 'tagID': '342', 'parentNodeId': '187', 'label': 'Telephone' },
  '205': { 'autoSelectTagIds': '50,34,111', 'tagID': '61', 'parentNodeId': '187', 'label': 'TV and multimedia' },
  '206': { 'autoSelectTagIds': '34,111', 'tagID': '64', 'parentNodeId': '166', 'label': 'Living Area' },
  '207': { 'autoSelectTagIds': '34,111', 'tagID': '219', 'parentNodeId': '166', 'label': 'Miscellaneous' },
  '208': { 'autoSelectTagIds': '34,111', 'tagID': '66', 'parentNodeId': '166', 'label': 'Pets' },
  '209': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '166', 'label': 'Room Theme' },
  '210': { 'autoSelectTagIds': '34,111', 'tagID': '71', 'parentNodeId': '209', 'label': 'Children' },
  '211': { 'autoSelectTagIds': '34,111', 'tagID': '407', 'parentNodeId': '209', 'label': 'Family' },
  '212': { 'autoSelectTagIds': '34,111', 'tagID': '72', 'parentNodeId': '209', 'label': 'Honeymoon' },
  '213': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '166', 'label': 'Room Type' },
  '214': { 'autoSelectTagIds': '34,111', 'tagID': '344', 'parentNodeId': '213', 'label': 'Apartment' },
  '215': { 'autoSelectTagIds': '34,111', 'tagID': '345', 'parentNodeId': '213', 'label': 'Budget' },
  '216': { 'autoSelectTagIds': '34,111', 'tagID': '346', 'parentNodeId': '213', 'label': 'Deluxe' },
  '217': { 'autoSelectTagIds': '34,111', 'tagID': '347', 'parentNodeId': '213', 'label': 'Double' },
  '218': { 'autoSelectTagIds': '34,111', 'tagID': '348', 'parentNodeId': '213', 'label': 'Quad' },
  '219': { 'autoSelectTagIds': '34,111', 'tagID': '349', 'parentNodeId': '213', 'label': 'Single' },
  '220': { 'autoSelectTagIds': '34,111', 'tagID': '350', 'parentNodeId': '213', 'label': 'Standard' },
  '221': { 'autoSelectTagIds': '34,111', 'tagID': '351', 'parentNodeId': '213', 'label': 'Superior' },
  '222': { 'autoSelectTagIds': '34,111', 'tagID': '352', 'parentNodeId': '213', 'label': 'Triple' },
  '223': { 'autoSelectTagIds': '34,111', 'tagID': '68', 'parentNodeId': '213', 'label': 'Sitting Area' },
  '224': { 'autoSelectTagIds': '34,111', 'tagID': '69', 'parentNodeId': '213', 'label': 'Suite' },
  '225': { 'autoSelectTagIds': '34,111', 'tagID': '69', 'parentNodeId': '166', 'label': 'Suite' },
  '226': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '0', 'label': 'Activity Tags' },
  '227': { 'autoSelectTagIds': '', 'tagID': '408', 'parentNodeId': '226', 'label': 'Activities (General)' },
  '228': { 'autoSelectTagIds': '', 'tagID': '239', 'parentNodeId': '226', 'label': 'Entertainment' },
  '229': { 'autoSelectTagIds': '239', 'tagID': '240', 'parentNodeId': '228', 'label': 'Band' },
  '230': { 'autoSelectTagIds': '239', 'tagID': '241', 'parentNodeId': '228', 'label': 'Cinema' },
  '231': { 'autoSelectTagIds': '239', 'tagID': '242', 'parentNodeId': '228', 'label': 'Comedy' },
  '232': { 'autoSelectTagIds': '239', 'tagID': '243', 'parentNodeId': '228', 'label': 'Disc Jockey' },
  '233': { 'autoSelectTagIds': '239', 'tagID': '244', 'parentNodeId': '228', 'label': 'Nightclub' },
  '234': { 'autoSelectTagIds': '239', 'tagID': '245', 'parentNodeId': '228', 'label': 'Theater Show' },
  '235': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '226', 'label': 'Interests' },
  '236': { 'autoSelectTagIds': '', 'tagID': '74', 'parentNodeId': '235', 'label': 'Adventure Travel' },
  '237': { 'autoSelectTagIds': '', 'tagID': '75', 'parentNodeId': '235', 'label': 'Amusement Parks' },
  '238': { 'autoSelectTagIds': '', 'tagID': '76', 'parentNodeId': '235', 'label': 'Architecture' },
  '239': { 'autoSelectTagIds': '', 'tagID': '77', 'parentNodeId': '235', 'label': 'Arts and Entertainment' },
  '240': { 'autoSelectTagIds': '', 'tagID': '78', 'parentNodeId': '235', 'label': 'Bird watching' },
  '241': { 'autoSelectTagIds': '', 'tagID': '79', 'parentNodeId': '235', 'label': 'College Visits' },
  '242': { 'autoSelectTagIds': '', 'tagID': '80', 'parentNodeId': '235', 'label': 'Computers/Internet/Social Media' },
  '243': { 'autoSelectTagIds': '', 'tagID': '81', 'parentNodeId': '235', 'label': 'Cooking and Culinary' },
  '244': { 'autoSelectTagIds': '', 'tagID': '82', 'parentNodeId': '235', 'label': 'Ecotourism' },
  '245': { 'autoSelectTagIds': '', 'tagID': '83', 'parentNodeId': '235', 'label': 'Education' },
  '246': { 'autoSelectTagIds': '', 'tagID': '84', 'parentNodeId': '235', 'label': 'Escape' },
  '247': { 'autoSelectTagIds': '', 'tagID': '85', 'parentNodeId': '235', 'label': 'Experiential Travel' },
  '248': { 'autoSelectTagIds': '', 'tagID': '86', 'parentNodeId': '235', 'label': 'Family Travel' },
  '249': { 'autoSelectTagIds': '', 'tagID': '87', 'parentNodeId': '235', 'label': 'Gardening/Gardens' },
  '250': { 'autoSelectTagIds': '', 'tagID': '88', 'parentNodeId': '235', 'label': 'Health and Well-being' },
  '251': { 'autoSelectTagIds': '', 'tagID': '89', 'parentNodeId': '235', 'label': 'Historical Vacations' },
  '252': { 'autoSelectTagIds': '', 'tagID': '90', 'parentNodeId': '235', 'label': 'Hot Air Ballooning' },
  '253': { 'autoSelectTagIds': '', 'tagID': '91', 'parentNodeId': '235', 'label': 'Luxury Travel' },
  '254': { 'autoSelectTagIds': '', 'tagID': '92', 'parentNodeId': '235', 'label': 'Mountain Vacations' },
  '255': { 'autoSelectTagIds': '', 'tagID': '93', 'parentNodeId': '235', 'label': 'Museums' },
  '256': { 'autoSelectTagIds': '', 'tagID': '94', 'parentNodeId': '235', 'label': 'Music' },
  '257': { 'autoSelectTagIds': '', 'tagID': '95', 'parentNodeId': '235', 'label': 'National Parks' },
  '258': { 'autoSelectTagIds': '', 'tagID': '392', 'parentNodeId': '235', 'label': 'Other' },
  '259': { 'autoSelectTagIds': '', 'tagID': '96', 'parentNodeId': '235', 'label': 'Photography' },
  '260': { 'autoSelectTagIds': '', 'tagID': '97', 'parentNodeId': '235', 'label': 'Pop Culture' },
  '261': { 'autoSelectTagIds': '', 'tagID': '98', 'parentNodeId': '235', 'label': 'Road Trips' },
  '262': { 'autoSelectTagIds': '', 'tagID': '99', 'parentNodeId': '235', 'label': 'Romantic Getaways' },
  '263': { 'autoSelectTagIds': '', 'tagID': '100', 'parentNodeId': '235', 'label': 'Shopping' },
  '264': { 'autoSelectTagIds': '', 'tagID': '101', 'parentNodeId': '235', 'label': 'Single Parent Travel' },
  '265': { 'autoSelectTagIds': '', 'tagID': '102', 'parentNodeId': '235', 'label': 'Whale Watching' },
  '266': { 'autoSelectTagIds': '', 'tagID': '103', 'parentNodeId': '235', 'label': 'Vineyards' },
  '267': { 'autoSelectTagIds': '110', 'tagID': '115', 'parentNodeId': '226', 'label': 'Local Area/Attractions' },
  '268': { 'autoSelectTagIds': '115,110', 'tagID': '195', 'parentNodeId': '267', 'label': 'Bar' },
  '269': { 'autoSelectTagIds': '115,110', 'tagID': '413', 'parentNodeId': '267', 'label': 'Bar - Sports Bar' },
  '270': { 'autoSelectTagIds': '115,110', 'tagID': '197', 'parentNodeId': '267', 'label': 'Beach' },
  '271': { 'autoSelectTagIds': '115,110', 'tagID': '235', 'parentNodeId': '267', 'label': 'Casino' },
  '272': { 'autoSelectTagIds': '115,110', 'tagID': '116', 'parentNodeId': '267', 'label': 'City' },
  '273': { 'autoSelectTagIds': '115,110', 'tagID': '117', 'parentNodeId': '267', 'label': 'Landmark' },
  '274': { 'autoSelectTagIds': '115,110', 'tagID': '118', 'parentNodeId': '267', 'label': 'Local Attraction' },
  '275': { 'autoSelectTagIds': '115,110', 'tagID': '119', 'parentNodeId': '267', 'label': 'Mountains' },
  '276': { 'autoSelectTagIds': '115,110', 'tagID': '120', 'parentNodeId': '267', 'label': 'Ocean' },
  '277': { 'autoSelectTagIds': '115,110', 'tagID': '121', 'parentNodeId': '267', 'label': 'River' },
  '278': { 'autoSelectTagIds': '115,110', 'tagID': '353', 'parentNodeId': '267', 'label': 'Riverwalk' },
  '279': { 'autoSelectTagIds': '115,110', 'tagID': '354', 'parentNodeId': '267', 'label': 'Skyline' },
  '280': { 'autoSelectTagIds': '115,110', 'tagID': '406', 'parentNodeId': '267', 'label': 'Sports Stadium' },
  '281': { 'autoSelectTagIds': '406,115,110', 'tagID': '381', 'parentNodeId': '280', 'label': 'Auto Racing' },
  '282': { 'autoSelectTagIds': '406,115,110', 'tagID': '280', 'parentNodeId': '280', 'label': 'Baseball' },
  '283': { 'autoSelectTagIds': '406,115,110', 'tagID': '382', 'parentNodeId': '280', 'label': 'Basketball' },
  '284': { 'autoSelectTagIds': '406,115,110', 'tagID': '388', 'parentNodeId': '280', 'label': 'Cricket' },
  '285': { 'autoSelectTagIds': '406,115,110', 'tagID': '281', 'parentNodeId': '280', 'label': 'Football' },
  '286': { 'autoSelectTagIds': '406,115,110', 'tagID': '282', 'parentNodeId': '280', 'label': 'Hockey' },
  '287': { 'autoSelectTagIds': '406,115,110', 'tagID': '390', 'parentNodeId': '280', 'label': 'Horse Racing' },
  '288': { 'autoSelectTagIds': '406,115,110', 'tagID': '395', 'parentNodeId': '280', 'label': 'Olympic' },
  '289': { 'autoSelectTagIds': '406,115,110', 'tagID': '402', 'parentNodeId': '280', 'label': 'Rugby' },
  '290': { 'autoSelectTagIds': '406,115,110', 'tagID': '283', 'parentNodeId': '280', 'label': 'Soccer' },
  '291': { 'autoSelectTagIds': '110', 'tagID': '355', 'parentNodeId': '267', 'label': 'Waterfront' },
  '292': { 'autoSelectTagIds': '', 'tagID': '232', 'parentNodeId': '226', 'label': 'Recreation' },
  '293': { 'autoSelectTagIds': '232', 'tagID': '234', 'parentNodeId': '292', 'label': 'Bowling' },
  '294': { 'autoSelectTagIds': '232', 'tagID': '237', 'parentNodeId': '292', 'label': 'Cycling' },
  '295': { 'autoSelectTagIds': '232', 'tagID': '238', 'parentNodeId': '292', 'label': 'Dancing' },
  '296': { 'autoSelectTagIds': '232,192,111', 'tagID': '247', 'parentNodeId': '292', 'label': 'Fitness Center' },
  '297': { 'autoSelectTagIds': '232,192,111', 'tagID': '249', 'parentNodeId': '292', 'label': 'Game room' },
  '298': { 'autoSelectTagIds': '232,192,111', 'tagID': '380', 'parentNodeId': '297', 'label': 'Arcade' },
  '299': { 'autoSelectTagIds': '232,192,111', 'tagID': '233', 'parentNodeId': '297', 'label': 'Billiards' },
  '300': { 'autoSelectTagIds': '232,192,111', 'tagID': '236', 'parentNodeId': '297', 'label': 'Darts' },
  '301': { 'autoSelectTagIds': '232,192,111', 'tagID': '264', 'parentNodeId': '297', 'label': 'Ping-pong' },
  '302': { 'autoSelectTagIds': '232,192,111', 'tagID': '250', 'parentNodeId': '292', 'label': 'Golf' },
  '303': { 'autoSelectTagIds': '250,232,192,111', 'tagID': '251', 'parentNodeId': '302', 'label': 'Club House' },
  '304': { 'autoSelectTagIds': '250,232,192,111', 'tagID': '252', 'parentNodeId': '302', 'label': 'Driving Range' },
  '305': { 'autoSelectTagIds': '250,232,192,111', 'tagID': '253', 'parentNodeId': '302', 'label': 'Golf Course' },
  '306': {
    'autoSelectTagIds': '250,232,192,111',
    'tagID': '254',
    'parentNodeId': '302',
    'label': 'Golf Course Feature'
  },
  '307': { 'autoSelectTagIds': '250,232,192,111', 'tagID': '255', 'parentNodeId': '302', 'label': 'Golf School' },
  '308': { 'autoSelectTagIds': '232,192,111', 'tagID': '256', 'parentNodeId': '302', 'label': 'Mini Golf' },
  '309': { 'autoSelectTagIds': '250,232,192,111', 'tagID': '400', 'parentNodeId': '302', 'label': 'Putting Green' },
  '310': { 'autoSelectTagIds': '250,232,192,111', 'tagID': '257', 'parentNodeId': '302', 'label': 'Pro Shop' },
  '311': { 'autoSelectTagIds': '232', 'tagID': '258', 'parentNodeId': '292', 'label': 'Hiking' },
  '312': { 'autoSelectTagIds': '232', 'tagID': '259', 'parentNodeId': '292', 'label': 'Horseback Riding' },
  '313': { 'autoSelectTagIds': '232', 'tagID': '260', 'parentNodeId': '292', 'label': 'Karaoke' },
  '314': { 'autoSelectTagIds': '232', 'tagID': '261', 'parentNodeId': '292', 'label': 'Kids\' club' },
  '315': { 'autoSelectTagIds': '232', 'tagID': '263', 'parentNodeId': '292', 'label': 'Park/Playground' },
  '316': { 'autoSelectTagIds': '232,192,111', 'tagID': '67', 'parentNodeId': '292', 'label': 'Pool/Swimming' },
  '317': { 'autoSelectTagIds': '165,232,192,111', 'tagID': '67', 'parentNodeId': '316', 'label': 'Children\'s Pool' },
  '318': { 'autoSelectTagIds': '107,232,192,111', 'tagID': '67', 'parentNodeId': '316', 'label': 'Indoor Pool' },
  '319': { 'autoSelectTagIds': '113,232,192,111', 'tagID': '67', 'parentNodeId': '316', 'label': 'Outdoor Pool' },
  '320': { 'autoSelectTagIds': '232,192,111', 'tagID': '276', 'parentNodeId': '316', 'label': 'Infinity Pool' },
  '321': { 'autoSelectTagIds': '192,111', 'tagID': '277', 'parentNodeId': '316', 'label': 'Waterfall' },
  '322': { 'autoSelectTagIds': '232,192,111', 'tagID': '278', 'parentNodeId': '316', 'label': 'Waterslide' },
  '323': { 'autoSelectTagIds': '232,192,111', 'tagID': '396', 'parentNodeId': '316', 'label': 'Wave Pool' },
  '324': { 'autoSelectTagIds': '232,192,111', 'tagID': '257', 'parentNodeId': '292', 'label': 'Pro Shop' },
  '325': { 'autoSelectTagIds': '232,192,111', 'tagID': '266', 'parentNodeId': '292', 'label': 'Recreational Facility' },
  '326': { 'autoSelectTagIds': '232', 'tagID': '268', 'parentNodeId': '292', 'label': 'Rock Climbing' },
  '327': { 'autoSelectTagIds': '232,192,111', 'tagID': '401', 'parentNodeId': '292', 'label': 'Rock Climbing Wall' },
  '328': { 'autoSelectTagIds': '232', 'tagID': '255', 'parentNodeId': '292', 'label': 'Sports Clinic' },
  '329': { 'autoSelectTagIds': '232,192,111', 'tagID': '387', 'parentNodeId': '292', 'label': 'Sports Courts/Fields' },
  '330': { 'autoSelectTagIds': '387,232,192,111', 'tagID': '280', 'parentNodeId': '329', 'label': 'Baseball' },
  '331': { 'autoSelectTagIds': '387,232,192,111', 'tagID': '382', 'parentNodeId': '329', 'label': 'Basketball' },
  '332': { 'autoSelectTagIds': '387,232,192,111', 'tagID': '385', 'parentNodeId': '329', 'label': 'Bocce' },
  '333': { 'autoSelectTagIds': '387,232,192,111', 'tagID': '281', 'parentNodeId': '329', 'label': 'Football' },
  '334': { 'autoSelectTagIds': '387,232,192,111', 'tagID': '283', 'parentNodeId': '329', 'label': 'Soccer' },
  '335': { 'autoSelectTagIds': '387,232,192,111', 'tagID': '271', 'parentNodeId': '329', 'label': 'Squash' },
  '336': { 'autoSelectTagIds': '387,232,192,111', 'tagID': '285', 'parentNodeId': '329', 'label': 'Tennis' },
  '337': { 'autoSelectTagIds': '387,232,192,111', 'tagID': '284', 'parentNodeId': '329', 'label': 'Volleyball' },
  '338': { 'autoSelectTagIds': '232', 'tagID': '286', 'parentNodeId': '292', 'label': 'Water Sports/Recreation' },
  '339': { 'autoSelectTagIds': '286,232', 'tagID': '287', 'parentNodeId': '338', 'label': 'Boating' },
  '340': { 'autoSelectTagIds': '286,232', 'tagID': '288', 'parentNodeId': '338', 'label': 'Canoeing' },
  '341': { 'autoSelectTagIds': '286,232', 'tagID': '368', 'parentNodeId': '338', 'label': 'Dock' },
  '342': { 'autoSelectTagIds': '286,232', 'tagID': '289', 'parentNodeId': '338', 'label': 'Fishing' },
  '343': { 'autoSelectTagIds': '286,232', 'tagID': '290', 'parentNodeId': '338', 'label': 'Kayaking' },
  '344': { 'autoSelectTagIds': '286,232', 'tagID': '291', 'parentNodeId': '338', 'label': 'Rafting' },
  '345': { 'autoSelectTagIds': '286,232', 'tagID': '292', 'parentNodeId': '338', 'label': 'Marina' },
  '346': { 'autoSelectTagIds': '286,232', 'tagID': '293', 'parentNodeId': '338', 'label': 'Sailing' },
  '347': { 'autoSelectTagIds': '286,232', 'tagID': '294', 'parentNodeId': '338', 'label': 'Scuba Diving' },
  '348': { 'autoSelectTagIds': '286,232', 'tagID': '295', 'parentNodeId': '338', 'label': 'Snorkeling' },
  '349': { 'autoSelectTagIds': '286,232', 'tagID': '296', 'parentNodeId': '338', 'label': 'Surfing' },
  '350': { 'autoSelectTagIds': '286,232', 'tagID': '297', 'parentNodeId': '338', 'label': 'Surfing Pool' },
  '351': { 'autoSelectTagIds': '286,232', 'tagID': '298', 'parentNodeId': '338', 'label': 'Water park' },
  '352': { 'autoSelectTagIds': '286,232', 'tagID': '299', 'parentNodeId': '338', 'label': 'Water skiing' },
  '353': { 'autoSelectTagIds': '286,232', 'tagID': '300', 'parentNodeId': '338', 'label': 'Windsurfing' },
  '354': { 'autoSelectTagIds': '232', 'tagID': '301', 'parentNodeId': '292', 'label': 'Winter/Ice Sports' },
  '355': { 'autoSelectTagIds': '301,232', 'tagID': '282', 'parentNodeId': '354', 'label': 'Hockey' },
  '356': { 'autoSelectTagIds': '301,232', 'tagID': '303', 'parentNodeId': '354', 'label': 'Ice Skating' },
  '357': { 'autoSelectTagIds': '301,232', 'tagID': '304', 'parentNodeId': '354', 'label': 'Snow Skiing' },
  '358': { 'autoSelectTagIds': '301,232', 'tagID': '404', 'parentNodeId': '354', 'label': 'Snowmobiling' },
  '359': { 'autoSelectTagIds': '232,192,111', 'tagID': '248', 'parentNodeId': '292', 'label': 'Yoga' },
  '360': { 'autoSelectTagIds': '232', 'tagID': '306', 'parentNodeId': '292', 'label': 'Zip lining' },
  '361': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '0', 'label': 'Supplemental Tags' },
  '362': { 'autoSelectTagIds': '', 'tagID': '409', 'parentNodeId': '361', 'label': 'Animals' },
  '363': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '361', 'label': 'Location' },
  '364': { 'autoSelectTagIds': '', 'tagID': '105', 'parentNodeId': '363', 'label': 'Beachside' },
  '365': { 'autoSelectTagIds': '', 'tagID': '106', 'parentNodeId': '363', 'label': 'Common area' },
  '366': { 'autoSelectTagIds': '', 'tagID': '107', 'parentNodeId': '363', 'label': 'Indoor/Interior' },
  '367': { 'autoSelectTagIds': '', 'tagID': '416', 'parentNodeId': '363', 'label': 'In-Pool' },
  '368': { 'autoSelectTagIds': '', 'tagID': '108', 'parentNodeId': '363', 'label': 'In-room' },
  '369': { 'autoSelectTagIds': '', 'tagID': '110', 'parentNodeId': '363', 'label': 'Off-Site' },
  '370': { 'autoSelectTagIds': '', 'tagID': '111', 'parentNodeId': '363', 'label': 'On-Site' },
  '371': { 'autoSelectTagIds': '', 'tagID': '113', 'parentNodeId': '363', 'label': 'Outdoor/Exterior' },
  '372': { 'autoSelectTagIds': '', 'tagID': '114', 'parentNodeId': '363', 'label': 'Poolside' },
  '374': { 'autoSelectTagIds': '', 'tagID': '356', 'parentNodeId': '363', 'label': 'Roof' },
  '375': { 'autoSelectTagIds': '', 'tagID': '219', 'parentNodeId': '361', 'label': 'Miscellaneous' },
  '376': { 'autoSelectTagIds': '', 'tagID': '159', 'parentNodeId': '361', 'label': 'People' },
  '377': { 'autoSelectTagIds': '', 'tagID': '62', 'parentNodeId': '376', 'label': 'Accessibility' },
  '378': { 'autoSelectTagIds': '159', 'tagID': '160', 'parentNodeId': '376', 'label': 'Adults' },
  '379': { 'autoSelectTagIds': '160,159', 'tagID': '161', 'parentNodeId': '378', 'label': 'Middle age' },
  '380': { 'autoSelectTagIds': '160,159', 'tagID': '162', 'parentNodeId': '378', 'label': 'Over 65' },
  '381': { 'autoSelectTagIds': '160,159', 'tagID': '163', 'parentNodeId': '378', 'label': 'Young Adults' },
  '382': { 'autoSelectTagIds': '159', 'tagID': '164', 'parentNodeId': '376', 'label': 'Businessmen/women' },
  '383': { 'autoSelectTagIds': '159', 'tagID': '165', 'parentNodeId': '376', 'label': 'Children' },
  '384': { 'autoSelectTagIds': '165,159', 'tagID': '166', 'parentNodeId': '383', 'label': 'Infants' },
  '385': { 'autoSelectTagIds': '165,159', 'tagID': '167', 'parentNodeId': '383', 'label': 'Teenagers' },
  '386': { 'autoSelectTagIds': '165,159', 'tagID': '168', 'parentNodeId': '383', 'label': 'Young Children' },
  '387': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '376', 'label': 'Ethnicity' },
  '388': { 'autoSelectTagIds': '159', 'tagID': '170', 'parentNodeId': '387', 'label': 'Asian/Pacific Islander' },
  '389': { 'autoSelectTagIds': '159', 'tagID': '171', 'parentNodeId': '387', 'label': 'Black/African' },
  '390': { 'autoSelectTagIds': '159', 'tagID': '172', 'parentNodeId': '387', 'label': 'Hispanic' },
  '391': { 'autoSelectTagIds': '159', 'tagID': '173', 'parentNodeId': '387', 'label': 'Other' },
  '392': { 'autoSelectTagIds': '159', 'tagID': '174', 'parentNodeId': '387', 'label': 'White/Caucasian' },
  '393': { 'autoSelectTagIds': '159', 'tagID': '175', 'parentNodeId': '376', 'label': 'Family' },
  '394': { 'autoSelectTagIds': '159', 'tagID': '412', 'parentNodeId': '376', 'label': 'Guests' },
  '395': { 'autoSelectTagIds': '159', 'tagID': '426', 'parentNodeId': '376', 'label': 'Group' },
  '396': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '376', 'label': 'Marital Status' },
  '397': { 'autoSelectTagIds': '159', 'tagID': '177', 'parentNodeId': '396', 'label': 'Couple' },
  '398': { 'autoSelectTagIds': '159', 'tagID': '178', 'parentNodeId': '396', 'label': 'Divorced' },
  '399': { 'autoSelectTagIds': '159', 'tagID': '179', 'parentNodeId': '396', 'label': 'Engaged' },
  '400': { 'autoSelectTagIds': '159', 'tagID': '180', 'parentNodeId': '396', 'label': 'Expecting Parents' },
  '401': { 'autoSelectTagIds': '159', 'tagID': '394', 'parentNodeId': '396', 'label': 'Honeymooning' },
  '402': { 'autoSelectTagIds': '159', 'tagID': '181', 'parentNodeId': '396', 'label': 'LGBT' },
  '403': { 'autoSelectTagIds': '159', 'tagID': '182', 'parentNodeId': '396', 'label': 'Married' },
  '404': { 'autoSelectTagIds': '159', 'tagID': '183', 'parentNodeId': '396', 'label': 'Other' },
  '405': { 'autoSelectTagIds': '159', 'tagID': '184', 'parentNodeId': '396', 'label': 'Single' },
  '406': { 'autoSelectTagIds': '159', 'tagID': '185', 'parentNodeId': '396', 'label': 'Single Parent' },
  '407': { 'autoSelectTagIds': '159', 'tagID': '186', 'parentNodeId': '376', 'label': 'Social group' },
  '408': { 'autoSelectTagIds': '159', 'tagID': '187', 'parentNodeId': '376', 'label': 'Staff' },
  '409': { 'autoSelectTagIds': '159', 'tagID': '189', 'parentNodeId': '376', 'label': 'Sex – Female' },
  '410': { 'autoSelectTagIds': '159', 'tagID': '190', 'parentNodeId': '376', 'label': 'Sex – Male' },
  '411': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '361', 'label': 'Photo Style' },
  '412': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '411', 'label': 'Aspect Ratio' },
  '413': { 'autoSelectTagIds': '', 'tagID': '363', 'parentNodeId': '412', 'label': 'Landscape (wide)' },
  '414': { 'autoSelectTagIds': '363', 'tagID': '364', 'parentNodeId': '412', 'label': 'Panorama (extra wide)' },
  '415': { 'autoSelectTagIds': '', 'tagID': '365', 'parentNodeId': '412', 'label': 'Portrait (tall)' },
  '416': { 'autoSelectTagIds': '', 'tagID': '366', 'parentNodeId': '412', 'label': 'Square' },
  '417': { 'autoSelectTagIds': '', 'tagID': '361', 'parentNodeId': '411', 'label': 'Close-up' },
  '418': { 'autoSelectTagIds': '', 'tagID': '397', 'parentNodeId': '411', 'label': 'Drawing/Illustration' },
  '419': { 'autoSelectTagIds': '', 'tagID': '377', 'parentNodeId': '411', 'label': 'Floor Plan' },
  '420': { 'autoSelectTagIds': '397', 'tagID': '109', 'parentNodeId': '411', 'label': 'Map' },
  '421': { 'autoSelectTagIds': '', 'tagID': '360', 'parentNodeId': '411', 'label': 'Monochrome' },
  '422': { 'autoSelectTagIds': '', 'tagID': '398', 'parentNodeId': '411', 'label': 'Rendering/CGI' },
  '423': { 'autoSelectTagIds': '', 'tagID': '399', 'parentNodeId': '411', 'label': 'Text Overlay' },
  '424': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '361', 'label': 'Time of Day' },
  '425': { 'autoSelectTagIds': '', 'tagID': '321', 'parentNodeId': '424', 'label': 'Dawn/Sunrise' },
  '426': { 'autoSelectTagIds': '', 'tagID': '319', 'parentNodeId': '424', 'label': 'Day' },
  '427': { 'autoSelectTagIds': '', 'tagID': '322', 'parentNodeId': '424', 'label': 'Dusk/Sunset' },
  '428': { 'autoSelectTagIds': '', 'tagID': '320', 'parentNodeId': '424', 'label': 'Evening/Night' },
  '429': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '361', 'label': 'Time of Year' },
  '430': { 'autoSelectTagIds': '', 'tagID': '328', 'parentNodeId': '429', 'label': 'Holiday' },
  '431': { 'autoSelectTagIds': '328', 'tagID': '331', 'parentNodeId': '430', 'label': 'Christmas' },
  '432': { 'autoSelectTagIds': '328', 'tagID': '329', 'parentNodeId': '430', 'label': 'New Year\'s' },
  '433': { 'autoSelectTagIds': '328', 'tagID': '330', 'parentNodeId': '430', 'label': 'Valentine\'s Day' },
  '434': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '429', 'label': 'Season' },
  '435': { 'autoSelectTagIds': '', 'tagID': '326', 'parentNodeId': '434', 'label': 'Autumn' },
  '436': { 'autoSelectTagIds': '', 'tagID': '324', 'parentNodeId': '434', 'label': 'Spring' },
  '437': { 'autoSelectTagIds': '', 'tagID': '325', 'parentNodeId': '434', 'label': 'Summer' },
  '438': { 'autoSelectTagIds': '', 'tagID': '327', 'parentNodeId': '434', 'label': 'Winter' },
  '439': { 'autoSelectTagIds': '', 'tagID': '', 'parentNodeId': '361', 'label': 'View From' },
  '440': { 'autoSelectTagIds': '', 'tagID': '333', 'parentNodeId': '439', 'label': 'Above' },
  '441': { 'autoSelectTagIds': '', 'tagID': '334', 'parentNodeId': '439', 'label': 'Back' },
  '442': { 'autoSelectTagIds': '', 'tagID': '335', 'parentNodeId': '439', 'label': 'Balcony' },
  '443': { 'autoSelectTagIds': '', 'tagID': '336', 'parentNodeId': '439', 'label': 'Front' },
  '444': { 'autoSelectTagIds': '', 'tagID': '337', 'parentNodeId': '439', 'label': 'Guest Room' },
  '445': { 'autoSelectTagIds': '', 'tagID': '338', 'parentNodeId': '439', 'label': 'Property' },
  '446': { 'autoSelectTagIds': '', 'tagID': '339', 'parentNodeId': '439', 'label': 'Rooftop' },
  '447': { 'autoSelectTagIds': '', 'tagID': '369', 'parentNodeId': '439', 'label': 'Satellite' },
  '448': { 'autoSelectTagIds': '', 'tagID': '340', 'parentNodeId': '439', 'label': 'Street' }
}
